<template>
  <div>
    <el-image v-if="src" fit="contain" :src="src" @error="actionRetry()">
      <div slot="error"></div>
    </el-image>
  </div>
</template>

<script>
// Nước cuối trước khi bỏ cuộc: tải lại chính link đó kèm cache-bust.
// Render sau 500ms, lỗi thì retry sau 2000ms, tối đa 2 lần; hết thì emit "exhausted"
// để component cha hiện khung ImageError.
const MAX_RETRIES = 2;

export default {
  name: "ImageRefresh",
  props: ["url"],
  data() {
    return {
      src: "",
      attempts: 0
    };
  },
  methods: {
    // Không phá query sẵn có (link cloud từ replaceLink có ?cToken=).
    bustCache(url) {
      return url + (url.indexOf("?") === -1 ? "?" : "&") + new Date().getTime();
    },
    actionRetry() {
      if (this.attempts >= MAX_RETRIES) {
        this.$emit("exhausted");
        return;
      }
      this.attempts++;
      setTimeout(() => {
        if (this.url) this.src = this.bustCache(this.url);
      }, 2000);
    }
  },
  mounted() {
    if (!this.url) {
      this.$emit("exhausted");
      return;
    }
    setTimeout(() => {
      this.src = this.bustCache(this.url);
    }, 500);
  }
};
</script>

<style scoped>

</style>
